export default "__VITE_ASSET__BztmZ5ql__"